import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const JobPriorityABadge = (props: StatusBadgeProps) => {
    const {
        width = "24",
        height = "24",
        viewBox = "0 0 20 20",
        ...rest
    } = props;

    return (
        <svg
            width={width}
            height={height}
            viewBox={viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="20" height="20" rx="3" fill="#A6D3F4" />
            <path
                d="M12.2584 14H13.6039L10.4759 5.9845H9.52145L6.39345 14H7.72745L8.39445 12.183H11.6029L12.2584 14ZM8.79695 11.0675L10.0044 7.7785L11.2004 11.0675H8.79695Z"
                fill="#21006E"
            />
        </svg>
    );
};
